const RECENT_MAP = {
  "0": { label: "T", className: "bg-[#2eb876] kbv-bxh-c-on-dark" },
  "1": { label: "H", className: "bg-[#fba700] kbv-bxh-c-on-dark" },
  "2": { label: "B", className: "bg-[#d71a1e] kbv-bxh-c-on-dark" },
};

const RECENT_KEYS = [
  "recentSixthResult",
  "recentFifthResult",
  "recentFourthResult",
  "recentThirdResult",
  "recentSecondResult",
];

export default function LeagueStanding({
  standings,
  highlightTeamId,
  colorInfos = [],
}) {
  if (!Array.isArray(standings) || standings.length === 0) return null;

  const sorted = [...standings].sort((a, b) => Number(a.rank) - Number(b.rank));

  const rows = sorted.map((row) => {
    const team = row.teams;
    const rowTeamId = row.teamId ?? team?.id;
    const isHighlight =
      highlightTeamId != null && String(rowTeamId) === String(highlightTeamId);
    const recentForm = RECENT_KEYS.map((k) => row[k]);
    const gd = Number(row.goalDifference);
    const gdStr = gd > 0 ? `+${gd}` : String(gd);
    const colorIndex = Number(row.color);
    const rankBgColor =
      !Number.isNaN(colorIndex) &&
      colorIndex >= 0 &&
      colorInfos?.[colorIndex]?.color
        ? colorInfos[colorIndex].color
        : null;

    return { row, team, isHighlight, recentForm, gdStr, rankBgColor };
  });

  const highlightBg = "bg-[var(--color-standing-highlight-bg,#2eb8761a)]";
  const highlightBorder =
    "border-l-4 border-l-[var(--color-standing-highlight,#2eb876)]";

  return (
    <div className="bg-[var(--background-header)] md:rounded border border-[var(--bxh-border)] md:overflow-hidden">
      <div className="relative flex overflow-hidden">
        <div className="pointer-events-none absolute top-0 bottom-0 left-[198px] w-2 z-30 bg-gradient-to-r from-black/10 to-transparent md:hidden" />

        <div className="flex-none md:flex-1 z-10">
          <table className="text-[13px] table-fixed md:w-full">
            <colgroup>
              <col style={{ width: 48 }} />
              <col className="w-[150px] md:w-auto" />
            </colgroup>
            <thead className="bg-[var(--surface-row-alt2)]">
              <tr className="h-[37px]">
                <th className="pl-3 pr-3 text-left kbv-bxh-fg font-semibold text-xs align-middle">
                  #
                </th>
                <th className="pl-0 pr-2 text-left kbv-bxh-fg font-semibold text-xs align-middle">
                  Đội bóng
                </th>
              </tr>
            </thead>
            <tbody className="kbv-bxh-fg">
              {rows.map(({ row, team, isHighlight, rankBgColor }) => (
                <tr
                  key={row.id}
                  className={`h-[40px] border-t border-[var(--bxh-border)] ${
                    isHighlight ? `${highlightBorder} ${highlightBg}` : ""
                  }`}
                >
                  <td
                    className={`pl-3 pr-3 align-middle w-[48px] ${
                      isHighlight ? highlightBg : "bg-[var(--background-header)]"
                    }`}
                  >
                    <span
                      className={`inline-flex w-6 h-6 items-center justify-center rounded text-[10px] lg:text-xs font-bold shrink-0 ${
                        rankBgColor
                          ? "kbv-bxh-c-on-dark"
                          : "bg-[var(--bxh-badge-bg)] kbv-bxh-badge"
                      }`}
                      style={
                        rankBgColor ? { backgroundColor: rankBgColor } : undefined
                      }
                    >
                      {row.rank}
                    </span>
                  </td>
                  <td
                    className={`pl-0 pr-2 align-middle max-w-[150px] ${
                      isHighlight ? highlightBg : "bg-[var(--background-header)]"
                    }`}
                  >
                    <div className="flex items-center gap-1.5 min-w-0">
                      {team?.logo && (
                        <div className="w-5 h-5 flex items-center justify-center shrink-0 overflow-hidden">
                          <img
                            src={team.logo}
                            alt={team?.name || ""}
                            width={20}
                            height={20}
                            className="w-5 h-5 object-contain"
                          />
                        </div>
                      )}
                      <span
                        title={team?.name}
                        className="block truncate text-xs lg:text-sm min-w-0 flex-1 kbv-bxh-fg"
                      >
                        {team?.name || "-"}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex-1 overflow-x-auto overscroll-x-contain md:flex-none md:overflow-x-visible league-standing-scrollbar-hide">
          <table className="text-[13px] table-auto w-full md:w-auto">
            <thead className="bg-[var(--surface-row-alt2)]">
              <tr className="h-[37px]">
                <th className="px-2 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                  Trận
                </th>
                <th className="px-2 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                  Điểm
                </th>
                <th className="px-2 text-center font-semibold text-xs whitespace-nowrap kbv-bxh-c-win align-middle">
                  T
                </th>
                <th className="px-2 text-center font-semibold text-xs whitespace-nowrap kbv-bxh-c-draw align-middle">
                  H
                </th>
                <th className="px-2 text-center font-semibold text-xs whitespace-nowrap kbv-bxh-c-lose align-middle">
                  B
                </th>
                <th className="px-2 text-center whitespace-nowrap kbv-bxh-fg font-semibold text-xs align-middle">
                  BT/BB
                </th>
                <th className="px-2 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                  +/-
                </th>
                <th className="px-2 pr-3 text-center kbv-bxh-fg font-semibold text-xs whitespace-nowrap align-middle">
                  Phong độ
                </th>
              </tr>
            </thead>
            <tbody className="kbv-bxh-fg">
              {rows.map(({ row, isHighlight, recentForm, gdStr }) => (
                <tr
                  key={row.id}
                  className={`h-[40px] border-t border-[var(--bxh-border)] transition-colors ${
                    isHighlight ? highlightBg : "hover:bg-[var(--bxh-row-hover)]"
                  }`}
                >
                  <td className="px-2 text-center whitespace-nowrap text-[13px] align-middle">
                    {row.totalCount}
                  </td>
                  <td className="px-2 text-center whitespace-nowrap font-bold text-[13px] align-middle">
                    {row.integral}
                  </td>
                  <td className="px-2 text-center whitespace-nowrap text-[13px] align-middle">
                    <span className="kbv-bxh-c-win">{row.winCount}</span>
                  </td>
                  <td className="px-2 text-center whitespace-nowrap text-[13px] align-middle">
                    <span className="kbv-bxh-c-draw">{row.drawCount}</span>
                  </td>
                  <td className="px-2 text-center whitespace-nowrap text-[13px] align-middle">
                    <span className="kbv-bxh-c-lose">{row.loseCount}</span>
                  </td>
                  <td className="px-2 text-center whitespace-nowrap text-[13px] align-middle">
                    {row.getScore}/{row.loseScore}
                  </td>
                  <td className="px-2 text-center whitespace-nowrap text-[13px] align-middle">
                    {gdStr}
                  </td>
                  <td className="px-2 pr-3 font-semibold whitespace-nowrap align-middle">
                    <div className="flex justify-end gap-1">
                      <span className="w-5 h-5 rounded text-[10px] font-semibold flex items-center justify-center shrink-0 bg-[var(--bxh-badge-bg)] kbv-bxh-badge">
                        ?
                      </span>
                      {recentForm.map((val, i) => {
                        const r = RECENT_MAP[val];
                        return (
                          <span
                            key={i}
                            className={`w-5 h-5 rounded text-[10px] font-semibold flex items-center justify-center shrink-0 ${
                              r
                                ? r.className
                                : "bg-[var(--bxh-badge-bg)] kbv-bxh-badge"
                            }`}
                          >
                            {r ? r.label : "?"}
                          </span>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
